import React from 'react';
import _get from 'lodash.get';
import {
  loadIndiaHPData,
  // loadMCDElectionData,
  loadCardInsertLiteData,
  // loadCardCollages,
} from 'routes/home/layouts/India/redux';
// import {
//   getOptimizeAbTestingScript,
//   optimizeAbTestingStyle,
// } from 'helpers/analytics/optimizeAbTest';
import { isApp } from 'utils/getParams';
import { commonHeadScripts } from 'helpers/scripts/headScripts';
import { loadLayoutDataUSHP } from 'reduxUtils/modules_v2/layout';
import { updatePrebidFlag } from 'helpers/ads/redux';
import {
  checkJarvisIsAdActive,
  checkJarvisAdsConfigForSS,
} from 'helpers/ads/utils';
import {
  getSiteConfig,
  updateCaimpaignAdsConfig,
} from 'reduxUtils/modules/common';
// import Layout from 'components_v2/desktop/Layout';
import { implementExperiment } from 'utils/primeUtil';
import { receiveAdsData } from 'helpers/ads/revenueRedux';
// CARD-3692: temporary disabled
// import { loadDefaultUtilityBeltData } from 'components_v2/common/UtilityBeltV2/redux';

import {
  getSectionsListFromBreadCrumb,
  getCustomDimension8,
  fireGA4Script,
} from 'utils/common';
import {
  // IMAGE_VERSION,
  TOI_LIVE_DOMAIN,
  DESKTOP_PLATFORM,
  BUSINESS_TOI,
  WEBVIEW_PLATFORM,
} from '../../../../../constants';
import Home from './Home';
import getCwvReportingObj from '../../../../../utils/getCwvReportingObj';

// import { loadElectionData } from '../../../../../components/ElectionV2/redux';
// import { loadUSElectionData } from '../../../../../components/ElectionV2/uselection_redux';
// import { loadLokSabhaElectionData } from '../../../../../components/ElectionV2/loksabha_redux';
// import desktopJSON from '../data/desktop';

const pageName = 'Home';

async function loadNextPage() {
  // if (!context) {
  //   return;
  // }
  // const dataPromiseArray = [];
  // dataPromiseArray.push(
  //   context.store.dispatch(
  //     loadHomePageData({
  //       isWapView: false,
  //       curpg: pageNum,
  //       isPrime,
  //     }),
  //   ),
  // );
}

async function action(context) {
  const dataPromiseArray = [];
  const localParams = { 0: context.path };
  const hreflangArr = [
    { lang: 'en-us', url: 'https://timesofindia.indiatimes.com/us' },
    { lang: 'en-IN', url: 'https://timesofindia.indiatimes.com' },
    { lang: 'x-default', url: 'https://timesofindia.indiatimes.com' },
  ];
  const isAppView = isApp(context.query);

  // existing state
  // eslint-disable-next-line one-var
  let state = context.store.getState(),
    sectionsNameList = [],
    cd8 = '';
  const { query: { geolocation } = {} } = context;
  // context.store.dispatch(setgeodata({ geo }));
  const isPrime = !!state.isPrime;
  const newParams = {
    ...localParams,
    curpg: 1,
    fullPath: '/',
    isWapView: false,
    isPrime,
  };

  if (!state.homepage.data) {
    // dataPromiseArray.push(
    //   context.store.dispatch(loadIndiaHPData(desktopJSON, true)),
    // );

    dataPromiseArray.push(
      context.store.dispatch(
        loadIndiaHPData({
          isWapView: false,
          isPrime,
          geocl: state.geocl,
          geolocation: state.ssrGeoCode,
          testExpando: context.query.test === 'expando',
        }),
      ),
    );
  }
  if (!state.homepage.cardsInsertsLite)
    dataPromiseArray.push(context.store.dispatch(loadCardInsertLiteData()));
  if (!state.header.data || !state.footer_v2.data) {
    dataPromiseArray.push(
      context.store.dispatch(loadLayoutDataUSHP(newParams)),
    );
  }
  // CARD-3692: temporary disabled
  // if (!state.utilityBelt.utilityBeltData && isPrime) {
  //   dataPromiseArray.push(context.store.dispatch(loadDefaultUtilityBeltData()));
  // }

  // Card-collage
  // if (!state.homepage.cardInserts) {
  //   dataPromiseArray.push(context.store.dispatch(loadCardCollages()));
  // }

  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  // Route data calls start
  const contextParams = context.params;

  // Route data calls end

  // wait for responses on server side
  if (typeof window === 'undefined') {
    await Promise.all(dataPromiseArray);
  }

  if (typeof window !== 'undefined') {
    window.categoryForGA = 'WEB-IN-NHP1';
    window.categoryForSearchGA = 'WEB-TOI-IN-HP';
  }

  // get updated state
  state = context.store.getState();

  // TODO: Election Widget
  // IMAGE_VERSION.version = state.common?.siteConfig?.imageVersion || 1;

  // const electionDataPromiseArray = [];

  // if (
  //   state.homepage?.data?.sections &&
  //   Array.isArray(state.homepage?.data?.sections) &&
  //   state.homepage?.data?.sections.length > 0 &&
  //   state.homepage?.data?.sections[0]?.tn === 'election'
  // ) {
  //   if (
  //     state.homepage?.data?.sections[0].tabs &&
  //     Array.isArray(state.homepage?.data?.sections[0].tabs) &&
  //     state.homepage?.data?.sections[0].tabs.length > 0
  //   ) {
  //     const assemblyElectionSelection = state.homepage?.data?.sections[0].tabs.filter(
  //       tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 2,
  //     );
  //     // const usElectionSelection = state.homepage?.data?.sections[0].tabs.filter(
  //     //   tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 3,
  //     // );
  //     // const lokSabhaElectionSelection = state.homepage?.data?.sections[0].tabs.filter(
  //     //   tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 1,
  //     // );

  //     if (
  //       assemblyElectionSelection &&
  //       Array.isArray(assemblyElectionSelection) &&
  //       assemblyElectionSelection.length > 0 &&
  //       !state?.electionV2?.refreshinterval
  //     ) {
  //       const assemblyElectionUrl =
  //         state.common?.siteConfig?.assemblyElectionUrl;
  //       electionDataPromiseArray.push(
  //         context.store.dispatch(
  //           loadElectionData(null, assemblyElectionUrl, true),
  //         ),
  //       );
  //     }
  //     // if (
  //     //   usElectionSelection &&
  //     //   Array.isArray(usElectionSelection) &&
  //     //   usElectionSelection.length > 0 &&
  //     //   !state?.usElection?.refreshinterval
  //     // ) {
  //     //   const usElectionUrl = state.common?.siteConfig?.usElectionUrl;
  //     //   electionDataPromiseArray.push(
  //     //     context.store.dispatch(loadUSElectionData(null, usElectionUrl, true)),
  //     //   );
  //     // }
  //     // if (
  //     //   lokSabhaElectionSelection &&
  //     //   Array.isArray(lokSabhaElectionSelection) &&
  //     //   lokSabhaElectionSelection.length > 0 &&
  //     //   !state?.lokSabhaElection?.refreshinterval
  //     // ) {
  //     //   const loksabhaElectionUrl =
  //     //     state.common?.siteConfig?.loksabhaElectionUrl;
  //     //   electionDataPromiseArray.push(
  //     //     context.store.dispatch(
  //     //       loadLokSabhaElectionData(null, loksabhaElectionUrl, true),
  //     //     ),
  //     //   );
  //     // }
  //   }
  // }

  // if (typeof window === 'undefined') {
  //   await Promise.all(electionDataPromiseArray);
  // }

  // state = context.store.getState();

  if (_get(state, 'navigation.data.breadCrumb', undefined)) {
    sectionsNameList = getSectionsListFromBreadCrumb(
      state.navigation.data.breadCrumbs,
    );
    cd8 = getCustomDimension8(sectionsNameList);
  }

  let status = 200;
  const title = 'Get Latest News Updates from Times Of India';
  const dataAvailable = true || !!state.homepage.data;

  if (typeof window === 'undefined' && !dataAvailable) {
    status = 404;
  }
  const seokeywords =
    'News, Breaking news, Latest news, Live news, Today news, News Today, India news, English news, Politics news, Top news in India';
  const isHeaderV2Flag = _get(
    state,
    'common.siteConfig.revenue.global_config.isHeaderV2',
    'true',
  );
  const layoutCompChunk =
    isHeaderV2Flag === 'true'
      ? 'toihomeindiadesktoplayout_new'
      : 'toihomeindiadesktoplayout_old';
  const getComponent = async pageTitle => {
    if (typeof window === 'undefined' && !dataAvailable) {
      return (
        <div>
          Something went wrong. Click{' '}
          <a href="https://timesofindia.indiatimes.com">here</a> to browse TOI
        </div>
      );
    }

    const prebidObj = _get(
      state,
      `common.siteConfig.prebid.templates.ushome.web`,
    );
    const pageRefreshTime = _get(
      state,
      `common.siteConfig.abexperiment.pagerefresh.refreshminutes.IndHP`,
      0,
    );
    const toiAssistUserSessionCount = _get(
      state,
      `common.siteConfig.toiAssistHPSessionCount`,
      5,
    );
    const electionFlag = _get(state, `common.siteConfig.showelection`);
    const siteSyncData = checkJarvisIsAdActive('siteSync');
    context.store.dispatch(updatePrebidFlag(prebidObj));
    const toiAssistBannerData = _get(
      state,
      'homepage.data.toiAssistBanner',
      undefined,
    );
    const { default: Layout } =
      isHeaderV2Flag === 'true'
        ? await import(/* webpackChunkName: "toihomeindiadesktoplayout_new" */ 'components_v3/desktop/Layout')
        : await import(/* webpackChunkName: "toihomeindiadesktoplayout_old" */ 'components_v2/desktop/Layout');

    let inpageminitv = _get(state, 'homepage.data.inpageminitv', undefined);

    if (_get(state, 'usElection.inpageminitv', undefined) === '1') {
      inpageminitv = _get(state, 'usElection.inpageminitv', undefined);
    }

    if (_get(state, 'electionV2.inpageminitv', undefined) === '1') {
      inpageminitv = _get(state, 'electionV2.inpageminitv', undefined);
    }

    const isInPageDock = inpageminitv === '1';

    return (
      <Layout
        title={pageTitle}
        params={newParams}
        query={Object.keys(context.query).length ? context.query : {}}
        adPosition="masthead"
        // hideAdBlockerDetector
        pageType="Home"
        showMiniTv={!isInPageDock}
        hideCyclicNav
        showWeatherInC
        enablePrimeFlow
        miniTvV2
        geolocation={state.ssrGeoCode}
        showCovid19PopUp
        disableTimesPointWidget
        showPollutionInfo
        enableCityChangeFeature
        toiAssistBannerData={toiAssistBannerData}
        isAppView={isAppView}
      >
        <Home
          contextParams={contextParams}
          hpData={state.homepage.data}
          electionData={state.electionV2}
          electionMCDData={state.homepage.electionMCDData}
          loadPageCallback={pageNum => loadNextPage(pageNum, context, isPrime)}
          isWapView={false}
          isInPageDock={isInPageDock}
          geolocation={geolocation}
          siteSync={siteSyncData}
          electionFlag={electionFlag === '1'}
          cardsInsertsLite={state.homepage.cardsInsertsLite}
          location={context.pathname}
          showCollage={context.query && context.query.showCollage !== undefined}
          refreshTime={parseFloat(pageRefreshTime, 10)}
          seokeywords={seokeywords}
          toiAssistUserSessionCount={
            toiAssistUserSessionCount
              ? parseInt(toiAssistUserSessionCount, 10)
              : toiAssistUserSessionCount
          }
        />
      </Layout>
    );
  };

  const getAdsTargetingObj = () => {
    const contentURL = TOI_LIVE_DOMAIN;
    const metaKeywords = seokeywords;
    const adConfig = {
      Tmpl_SCN: 'home',
      Channel: 'toi',
    };
    return {
      Meta_Keywords: metaKeywords,
      Content_URL: contentURL,
      SCN: 'home',
      ...adConfig,
    };
  };

  const adsTargetingObj = getAdsTargetingObj();
  if (!isPrime && typeof window === 'undefined') {
    const caimpaignConfig = checkJarvisAdsConfigForSS({
      jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
      isWapView: false,
      SCN: 'home',
      pathname: context?.pathname,
      ...adsTargetingObj,
    });
    context.store.dispatch(updateCaimpaignAdsConfig(caimpaignConfig));
    const revenueAds = _get(state, 'homepage.data.revenue');
    context.store.dispatch(receiveAdsData(revenueAds));
  }
  if (typeof window !== 'undefined') {
    fireGA4Script();
  }

  const schemaArr = [
    {
      data:
        ' { "@context": "https://schema.org", "@type": "WebSite", "name": "Times of India", "alternateName" : "TOI", "url":"https://timesofindia.indiatimes.com", "potentialAction":{ "@type":"SearchAction", "target": { "@type": "EntryPoint", "urlTemplate": "https://timesofindia.indiatimes.com/topic/{search_term_string}" }, "query-input": "required name=search_term_string" } } ',
    },
  ];
  if (isPrime) {
    schemaArr.push({
      data:
        '  { "@context": "https://schema.org/", "@type": "WebPage","name": "home page", "url": "http://timesofindia.indiatimes.com", "isAccessibleForFree": "true", "isPartOf": { "@type": ["CreativeWork", "Product"], "name": "Times of india", "productID": "timesofindia.com:showcase" } } ',
    });
  }
  // const gtmIDForOptimisely = ['GTM-54ZCD8R'];
  const indirectInterstitial = _get(
    state,
    'homepage.data.indirectInterstitial',
    null,
  );
  const jconf = indirectInterstitial
    ? {
        webInterstitial: {
          indirect: _get(state, 'homepage.data.indirectInterstitial', {}),
        },
      }
    : {};
  const { webInterstitial } = _get(state, 'common.siteConfig.revenue', {});
  if (webInterstitial) {
    jconf.webInterstitial = {
      ...webInterstitial,
      ...(jconf.webInterstitial || {}),
    };
  }
  const gtmIDForOptimisely = ['GTM-KCRX3PN'];
  let cwvReportingInfo = {};

  try {
    cwvReportingInfo = getCwvReportingObj({
      dataAvailable,
      state,
      platform: DESKTOP_PLATFORM,
      browsingPlatform: isAppView ? WEBVIEW_PLATFORM : DESKTOP_PLATFORM,
      businessProperty: BUSINESS_TOI,
      pageName: 'homepage',
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('issue in cwvReportingInfo');
    cwvReportingInfo = {};
  }

  return {
    title,
    chunks: ['homedesktop', layoutCompChunk],
    seoData: state?.homepage?.data?.seo
      ? { ...state?.homepage?.data?.seo, schema: schemaArr }
      : {
          title:
            'News - Latest News, Breaking News, Bollywood, Sports, Business and Political News | Times of India',
          canonical: 'https://timesofindia.indiatimes.com/',
          description:
            'Top News in India: Read Latest News on Sports, Business, Entertainment, Blogs and Opinions from leading columnists. Times of India brings the Breaking News and Latest News Headlines from India and around the World.',
          keywords: seokeywords,
          ogimage: 'https://static.toiimg.com/photo/47529300.cms',
          alternate: '',
          alternateApp:
            'android-app://com.toi.reader.activities/toi.index.deeplink/HomeL1/Top-01',
          amplink: 'https://timesofindia.indiatimes.com/amp_home',
          hreflang: hreflangArr,
          schema: schemaArr,
        },
    gutterType: 'v2',
    status,
    component: await getComponent(title),
    adsTargetingObj,
    scrollRestoration: 'auto',
    maxAge: 60,
    gaData: {
      dimension9: pageName,
      dimension8: cd8,
    },
    preconnectDomains: ['//tpapi.timespoints.com'],
    headTags: [
      ...commonHeadScripts,
      <script
        dangerouslySetInnerHTML={{
          __html: implementExperiment(),
        }}
      />,
      // <script
      //   dangerouslySetInnerHTML={{
      //     __html: getOptimizeAbTestingScript(gtmIDForOptimisely[0]),
      //   }}
      // />,
      // <style dangerouslySetInnerHTML={{ __html: optimizeAbTestingStyle }} />,
    ],
    isPrime: state.isPrime,
    gtmIDList: gtmIDForOptimisely,
    isPerfExperimented: !state.isPrime,
    useVariableFonts: !state.isPrime,
    inlineFirstFoldCSS: !state.isPrime,
    staticGpt: state.ssrGeoCode === '2',
    enableInterstitial: true,
    jarvisAdsConfig: jconf,
    ssrGeoInfo: _get(state, 'homepage.data.ssrGeoInfo', null),
    firstfoldColumbiaJs: true,
    cwvReportingInfo,
  };
}

export default action;
